/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const subtitleSearchResultSchema = z.object({
  startMs: z.number(),
  endMs: z.number(),
  text: z.string(),
  entryIndices: z.array(z.number()),
});

export type ISubtitleSearchResult = z.infer<typeof subtitleSearchResultSchema>;

export const searchCollectionSubtitlesResponseDataSchema = z.array(subtitleSearchResultSchema);

export type ISearchCollectionSubtitlesResponseData = z.infer<
  typeof searchCollectionSubtitlesResponseDataSchema
>;

export const searchCollectionSubtitlesResponseSchema = createApiResponseSchema(
  searchCollectionSubtitlesResponseDataSchema,
) as z.ZodSchema<IAPI<ISearchCollectionSubtitlesResponseData>>;

export type ISearchCollectionSubtitlesResponse = IAPI<ISearchCollectionSubtitlesResponseData>;
